import AsyncAlpine from "async-alpine";
import Alpine from "alpinejs";
import "../js/collection-metal-filter.js";

// Initialize Alpine
window.Alpine = Alpine;
AsyncAlpine.init(Alpine);
Alpine.start();
